import Drawer from '@navi/web-ui/lib/primitives/Drawer/Drawer';
import { useEffect, useRef, useState } from 'react';
import styles from '../../components/CaseHistory/CaseBrowsingHistory.module.scss';
import CaseBrowserHistory from './CaseBrowsingHistory';

interface CaseBrowsingHistoryProps {
  showCaseBrowsingHistory: boolean;
  toggleCaseHistory: (show: boolean) => void;
}

const CaseHistory = (props: CaseBrowsingHistoryProps) => {
  const { showCaseBrowsingHistory, toggleCaseHistory } = props;
  const [show, setShow] = useState(false);
  const drawerCloseIntervalRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    toggleCaseHistory(false);
  }, [window?.location?.href]);

  useEffect(() => {
    if (showCaseBrowsingHistory) {
      clearTimeout(drawerCloseIntervalRef.current);
      setShow(showCaseBrowsingHistory);
    }
  }, [showCaseBrowsingHistory]);

  const handleHistoryVisibility = () => {
    toggleCaseHistory(!showCaseBrowsingHistory);
    clearTimeout(drawerCloseIntervalRef.current);
    drawerCloseIntervalRef.current = setTimeout(() => {
      setShow(false);
    }, 500);
  };

  return (
    <Drawer
      open={showCaseBrowsingHistory}
      onClose={() => handleHistoryVisibility()}
      headerText={'Case Browsing History'}
      headerContainerClasses={styles.caseBrowsingHistoryContainer}
      usePadding={false}
    >
      {show ? <CaseBrowserHistory /> : <></>}
    </Drawer>
  );
};

export default CaseHistory;
